<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g fill="none">
      <path
        d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"
      />
      <path
        fill="currentColor"
        d="M8.73 9c.958-1.813 2.752-3 4.741-3c1.465 0 2.807.632 3.802 1.686a1 1 0 0 0 1.454-1.372C17.387 4.894 15.533 4 13.471 4c-3.179 0-5.827 2.097-6.926 5H5a1 1 0 0 0 0 2h1.058a8.681 8.681 0 0 0 0 2H5a1 1 0 1 0 0 2h1.545c1.099 2.903 3.747 5 6.926 5c2.062 0 3.917-.894 5.256-2.314a1 1 0 0 0-1.454-1.372C16.278 17.368 14.936 18 13.47 18c-1.989 0-3.783-1.187-4.741-3H13a1 1 0 1 0 0-2H8.075a6.815 6.815 0 0 1 0-2H13a1 1 0 1 0 0-2z"
      />
    </g>
  </svg>
</template>
